
export class CookiesHelper {
    
    public static setCookie(name: string, value: string) {
        // Compute the cookie expiration date
        const date_exp = new Date();
        date_exp.setTime(date_exp.getTime()+(30*24*3600*1000)); // 30 days
        // Set cookie
        document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + date_exp.toUTCString() + "; path=/";
    }

    public static getCookie(name: string): string | undefined {
        const arg = name + "=";
        const alen = arg.length;
        const clen = document.cookie.length;
        let i = 0;
        while (i < clen) {
            const j = i + alen;
            if (document.cookie.substring(i, j) === arg) {
                return CookiesHelper.getCookieVal(j);
            }
            i = document.cookie.indexOf(" ", i) + 1;
            if (i == 0) break;
        }
        return undefined;
    }

    private static getCookieVal(offset: number): string {
        let endstr: number = document.cookie.indexOf(";", offset);
        if (endstr === -1) {
            endstr = document.cookie.length;
        }
        return unescape(document.cookie.substring(offset, endstr));
    }
}